import { DTMainGroup, FBD_MainGroup } from '@rabbit/data/types';
import { useFirestoreQueryData } from '@react-query-firebase/firestore';
import { query, where } from 'firebase/firestore';
import { DR_Holding_Proxy, DR_MainGroup } from '@rabbit/data/portal';

export interface UseGetMainGroupDataProps {
  mainGroupId?: string;
  enabled?: boolean;
}

export interface MainGroupDataShape {
  mainGroup: DTMainGroup | null;
}

export const useGetMainGroupData = ({
  mainGroupId,
  enabled = true,
}: UseGetMainGroupDataProps) => {
  // Create query for main group by docid
  const mainGroupQuery = mainGroupId
    ? query(DR_MainGroup.collection(), where('docid', '==', mainGroupId))
    : undefined;

  const mainGroupResult = useFirestoreQueryData(
    ['mainGroup', mainGroupId],
    mainGroupQuery,
    {
      subscribe: true,
    },
    {
      enabled: enabled && !!mainGroupId,
    }
  );

  const getData = (): MainGroupDataShape => {
    const mainGroup = mainGroupResult?.data?.[0] || null;

    return {
      mainGroup,
    };
  };

  return {
    data: getData(),
    isLoading: mainGroupResult.isLoading,
    error: mainGroupResult.error,
    refetch: mainGroupResult.refetch,
  };
};
